<template>
    <link-table-action-button :url="url" :label="trans('buttons.update')" :grid="grid">
        <inline-svg
            :url="require('../../../../images/actions/edit.svg')"
            classes="table-action-cell__icon"
        >
        </inline-svg>
    </link-table-action-button>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'

    export default {
        props: ['url', 'grid'],

        components: {
            InlineSvg
        }
    }
</script>
